import React, { useEffect, useState } from "react";
import FormRender from "../../components/Form/Renderer/RenderForm";
import { ResetPasswordConfig } from "../../utils/constant/formConfig.constant";
import { validateResetPasswordLink } from "../../services/public.services";
import { toastMessage } from "../../utils/helper/myToast";
import { Image } from "../../common/ui/Image";
import ContainerHeader from "../../common/ui/ContainerHeader";
import TimeButton from "../../common/ui/time/TimeButton";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { loginSelector, setUserInfo } from "@/store/features/loginSlice";
import { logout } from "@/services/common/user.services";
import { motion } from "framer-motion";
import { useAppDispatch } from "@/store/store";

interface SetNewPasswordProps {
  token: string;
}
const SetNewPassword: React.FC<SetNewPasswordProps> = ({ token }) => {
  const [success, setSuccess] = useState(false);
  const { currentUser } = useSelector(loginSelector);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const handleFormSubmit = async (data: any) => {
    const res: any = await validateResetPasswordLink({ newPassword: data?.password, token });

    if (res?.status === 200) {
      const { message, isError } = res.data;
      setSuccess(true);
      return toastMessage(message, isError);
    } else {
      console.log("Error", res);
      const { message, isError } = res?.response?.data || {};
      if (message) {
        return toastMessage(message, isError);
      }
      if (res.message) {
        return toastMessage(res.message, true);
      }
    }
  };

  const backToLogin = () => navigate("/login");

  useEffect(() => {
    const handleAuthentication = async () => {
      if (!currentUser) {
        setIsLoading(false);
        return;
      }
      try {
        await logout();
        dispatch(setUserInfo({ user: null, orgs: null }));
      } catch (error) {
        console.error("Authentication error:", error);
      } finally {
        setIsLoading(false);
      }
    };

    handleAuthentication();
  }, []);

  // console.log({ isLoading, T: "Set New Password", currentUser });
  if (isLoading)
    return (
      <div className="flex flex-col items-center justify-center h-full">
        <motion.div
          className="w-20 h-20 rounded-full"
          style={{
            background: "conic-gradient(from 0deg, #FDF7FF, #FDF7FF, #FDF7FF, #C59EF7, #9A6AD4, #6F36BC)",
            maskImage: "radial-gradient(transparent 55%, black 55%)",
            WebkitMaskImage: "radial-gradient(transparent 55%, black 55%)",
          }}
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        />
        <motion.h2
          className="mt-4 text-13 font-normal !leading-normal text-gray-700"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          Getting things ready...
        </motion.h2>
      </div>
    );

  return (
    <div className="mt-12 w-[500px]">
      {success ? (
        <div className=" flex flex-col items-center">
          <Image src="/images/done.svg" alt="email-send-image" className=" hover:cursor-pointer" />
          <ContainerHeader headingClassName=" text-xl !leading-normal font-black text-text-label" heading="Password updated successfully!" />
          <TimeButton handleClick={backToLogin} text="You will be automatically re-directed to the Lystproof login page." btnText="Back to Login" />
        </div>
      ) : (
        <FormRender handleFormSubmit={handleFormSubmit} formConfig={ResetPasswordConfig} />
      )}
    </div>
  );
};

export default SetNewPassword;
